import React, { useContext } from "react";
import { ReactSession } from "react-client-session";
import { useNavigate } from "react-router-dom";

import FormContext from "../../context/FormContext";
import ManualEntryHeader from "../manual_entry/ManualEntryHeader";
import Sidebar from "../operator_home/sidebar/Sidebar.jsx";
import Details from "../manual_entry/Details";
import ManualEntryTableContainer from "../manual_entry/ManualEntryTableContainer";

import "./ManualEntry.css";

const ManualEntry = () => {
  const navigate = useNavigate();
  const { setIsFormOpen } = useContext(FormContext);

  const boxId = ReactSession.get("box_id");
  const existingBox = () => {
    navigate("/stockist-report");
  };

  const addNewBox = () => {
    setIsFormOpen(true);
    navigate("/operator");
  };

  return (
    <div className="manual-entry-container">
      <ManualEntryHeader />
      <Sidebar className="manual-entry-sidebar" />
      {boxId ? (
        <>
          <Details />
          <ManualEntryTableContainer />
        </>
      ) : (
        <div>
          <div className="delete-modal">
            <div className="delete-modal-desc">
              {/*<img alt="bin" className="delete-modal-img" src={exit} />*/}
              <p className="delete-modal-desc-para dmdp-1">
                Please add a new claim or enter into a existing claim!
              </p>
            </div>
            <div className="delete-modal-btns">
              <button
                onClick={existingBox}
                className="box-complete-btn"
                id="yes"
              >
                Enter in a existing claim
              </button>
              <button
                onClick={addNewBox}
                className="{/*delete-modal-btn*/} box-complete-btn"
                id="no"
              >
                Add a new claim!
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManualEntry;
